<template>
  <div
    class="pay-failed"
    :class="{ mobile: Base.checkSysteam() === 'MOBILE' }"
    v-if="isShow"
  >
    <div class="dialog">
      <div class="close" @click="isShow = false"></div>
      <div class="dialog-header">{{ $t("message.payFailed") }}</div>
      <div class="tip">{{ message }}</div>
      <div class="btn" @click="isShow = false">{{ $t("message.confirm") }}</div>
    </div>
  </div>
</template>

<script>
import Base from "../../utils/base";
export default {
  data() {
    return {
      Base,
      isShow: false,
      message: "",
    };
  },
  methods: {
    show(message) {
      this.message = message;
      this.isShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.pay-failed {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  .dialog {
    width: 407px;
    height: 250px;
    background: #fff;
    border-radius: 5px;
    padding: 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    position: relative;
    animation: dialog-appearance 0.2s;

    .dialog-header {
      position: relative;
      font-size: 20px;
      line-height: 20px;
      font-weight: 500;
      font-size: 20px;
      color: #191919;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .close {
      position: absolute;
      top: 25px;
      right: 10px;
      width: 20px;
      height: 20px;
      cursor: pointer;
      background: url("../../assets/dialog-close.png") no-repeat center;
    }

    .btn {
      background: linear-gradient(to right, #ed8d8a 1px, #ea6461);
      color: #fff;
      width: 181px;
      height: 54px;
      border-radius: 10px;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .tip {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      font-size: 16px;
      color: #3d3d3d;
      text-wrap-mode: wrap;
      line-height: 20px;
      text-align: center;
    }
  }

  // 移动端样式
  &.mobile {
    .dialog {
      max-width: 85vw;
      overflow: hidden;

      .btn {
        flex-shrink: 0;
        max-width: 80%;
      }
    }
  }
}
</style>
